'use strict';

require('../../styles/grid-fallback.pcss');